export interface tablaNuevoCotizaciones {
    id: string,
    Servicio: string;
    Vehiculo: string;
    Inicio: string;
    Fin: string;
    Origen: string;
    Destino: string;
    Pasajeros: string;
    Viaje: string;
    CantVehiculos: string;
    Unitario: string;
    VrServicio: string;
    
  }
  
  export const TABLANUEVOCOTIZACIONES: tablaNuevoCotizaciones[] = [
    {
      id: "1",
      Servicio: "CORDOBA-EL GUAMO",
      Vehiculo: "FFFFF",
      Inicio: "CORDOBA",
      Fin: "EL GUAMO",
      Origen: "EL GUAMO",
      Destino: "EL GUAMO",
      Pasajeros: "EL GUAMO",
      Viaje: "EL GUAMO",
      CantVehiculos: "EL GUAMO",
      Unitario: "EL GUAMO",
      VrServicio: "EL GUAMO",
    },

  ]